/**
 * @generated SignedSource<<7ac5c266083035e34492b5603940204d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildDonationScreenContent_guild$data = {
  readonly donationCurrency: string | null | undefined;
  readonly id: string;
  readonly minimumDonationAmount: number | null | undefined;
  readonly slugId: string;
  readonly stripeAccountId: string | null | undefined;
  readonly " $fragmentType": "GuildDonationScreenContent_guild";
};
export type GuildDonationScreenContent_guild$key = {
  readonly " $data"?: GuildDonationScreenContent_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildDonationScreenContent_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildDonationScreenContent_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimumDonationAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "donationCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeAccountId",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "0df6e973f6edec4d38d19b8b2567699d";

export default node;
